import React, { Component } from 'react';
import '../Assets/Styles/ButtonMenuItem.css';

import classNames from 'classnames'

class ButtonMenuItem extends Component {
	constructor() {
    super();
    this.state = {
      showTickets: false
    }

    window.addEventListener('mouseup', evt => this.hideTickets(evt));

  }


  handleClick(){
  	this.props.openModal(this.props.buttonMenuItem.target)
  	if(this.props.buttonMenuItem.target === 'tickets'){
      this.setState({showTickets: true})

    }
  }

  hideTickets(evt) {
    if(this.state.showTickets){
      this.setState({ showTickets: false });
    }
  }

  render() {
  	let classes = classNames({
  		'ButtonMenuItem': true,
  		'showtickets': this.state.showTickets
  	})
    return (
      <li className={this.props.buttonMenuItem.label.toLowerCase() + " " + classes} onClick={this.handleClick.bind(this)}>{this.props.buttonMenuItem.label}
      	{ this.props.buttonMenuItem.target === 'tickets' ?
      		<div className="tickets-container">
  		  		<a href="http://www.fandango.com/guardiansofthegalaxyvol.2_190573/movietimes" target="_blank"><span className="fandango">fandango</span></a>
  		  		<a href="http://www.movietickets.com/movie/mid/191861/n/Guardians-of-the-Galaxy-Vol-2#.WNF9ihLyu9Z" target="_blank"><span className="movietickets">movietickets</span></a>
      		</div>
      		: null }
      </li>
    );
  }
}

export default ButtonMenuItem;



// WEBPACK FOOTER //
// ./src/Components/ButtonMenuItem.js